//get config.json to override settings
let data = { baseUrl: "", wsUrl: "" };
try {
  //@ts-ignore
  const res = await fetch("/config.json");
  if (res.status === 200) {
    //@ts-ignore
    data = await res.json();
  }
  console.log(data);
} catch (e) {
  console.warn("fetch config.json failed", e);
}
export const API_URL =
  data.baseUrl ||
  process.env?.REACT_APP_API ||
  // "https://dev-api.agi7.ai/agi7/api";
  "https://api.dev.agi7.ai/agi7/api";
export const WS_URL =
  data.wsUrl ||
  process.env?.REACT_APP_WS ||
  // "wss://dev-ws.agi7.ai/agi7/api/user/ws";
  "wss://ws.dev.agi7.ai/agi7/api/user/ws";
export const ITEMS_PER_PAGE = 6;
export const SALT = "enFs3yRDWXaSSFZnNN5DKZW1yQPapBIM";
export const ENV = process.env?.NODE_ENV;
export const Min_MinDetSize = 120;
export const Max_MinDetSize = 1000;
export const Default_MinDetSize = Min_MinDetSize;

export const personKey = "person";
export const vehicleKey = "vehicle";
export const onMotorVehicleKey = "non_motor_vehicle";
export const smokingKey = "smoking";
export const gunKey = "human_with_gun";
export const databaseKey = "database";
export const conflagrationKey = "conflagration";
export const doorOpenKey = "door_open";
export const trashCanKey = "trash_can";
export const carTypeAmbulanceKey = "car_type_ambulance";
export const carModelModel3Key = "car_model_model3";
export const humanWalkingKey = "human_walking";
export const humanStandingKey = "human_standing";
export const holdingSomethingKey = "holding_something";
export const inspectionKey = "inspection";
export const noHardHat = "no_hard_hat";
export const noVest = "no_vest";
export const chunkSize = 1024 * 512; // no more than 512KB
export const REGION_INDEX_COLOR = {
  0: "#EF6C00",
  1: "#AA47BD",
  2: "#6A9F39",
  3: "#3E83F6",
};

export const googleSSOClientId =
  ENV === "development"
    ? "489672176888-qq5jbe33bmsv9chb7vckg38rd5ecku31.apps.googleusercontent.com"
    : "234335647441-lndjoi3ubeqvhjn4bjhucealr38c117e.apps.googleusercontent.com";

export const microsoftSSOClientId =
  ENV === "development"
    ? "f7f328b9-39fe-4efe-8451-d1ccb9876790"
    : "f95d52a8-7b13-4b53-b261-816652f1b7f1";

export const CROSS_LINE_B_BG_COLOR = {
  0: "#DCE7FD",
  1: "#F7D8FD",
  2: "#F2F7ED",
  3: "#FEF4EB",
};

export const enum CheckState {
  unchecked,
  checked,
  indeterminate,
}
export const ConfirmModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    borderRadius: "16px",
    borderWidth: "1px",
    padding: "24px",
  },
};
export const ALERT_VEHICLE_CAR_COLOR = {
  color_unknown: "#888888",
  black: "#222222",
  white: "#FFFFFF",
  gray: "#CBCBCB",
  red: "#FF0000",
  blue: "#4D88DF",
  yellow: "#FFE600",
  orange: "#FF6B00",
  brown: "#9D6530",
  green: "#4CAF50",
  purple: "#9044B4",
  cyan: "#00FFFF",
  pink: "#FFD5D2",
};

export enum USER_ROLE {
  Distributor = "distributor",
  DealerRep = "dealer_rep",
  Dealer = "dealer",
  Customer = "customer",
  Admin = "admin",
  OrgAdmin = "org_admin",
  ContactUser = "contact_user",
  SiteManager = "site_manager",
  Operator = "operator",
  Technician = "technician",
  Inspector = "inspector",
  Dispatcher = "dispatcher",
  ProjectManager = "project_manager",
  DealerAdmin = "dealer_admin",
  Scheduler = "scheduler",
}

export enum DB_STORE {
  SNAPSHOT = "snapshots",
  PRESET = "presets",
  EVENT_PIC = "event_pics",
  GOOGLE_DRIVE_CACHE = "google_drive_cache",
}

export enum AlertPageMode {
  Basic = "basic",
  Focus = "focus",
}

export const ORGANIZATION_USER_ROLE_COLORS = {
  contact_user: {
    textColor: "text-blue-700",
    bgColor: "bg-blue-100",
  },
  site_manager: {
    textColor: "text-teal-700",
    bgColor: "bg-teal-100",
  },
  org_admin: {
    textColor: "text-yellow-700",
    bgColor: "bg-yellow-100",
  },
  technician: {
    textColor: "text-purple-700",
    bgColor: "bg-purple-100",
  },
  project_manager: {
    textColor: "text-indigo-700",
    bgColor: "bg-indigo-100",
  },
  operator: {
    textColor: "text-pink-700",
    bgColor: "bg-pink-100",
  },
  dispatcher: {
    textColor: "text-red-700",
    bgColor: "bg-red-100",
  },
  inspector: {
    textColor: "text-green-700",
    bgColor: "bg-green-100",
  },
  dealer_admin: {
    textColor: "text-orange-700",
    bgColor: "bg-orange-100",
  },
  scheduler: {
    textColor: "text-gray-700",
    bgColor: "bg-gray-100",
  },
};

export enum ALERT_PROCESS_STATUS {
  Detected = "detected",
  Todo = "todo",
  Investigate = "investigate",
  ContactPd = "contact_pd",
  Resolved = "resolved",
  Closed = "closed",
  FalseAlarm = "false_alarm",
}

export enum ALERT_PROCESS_STATUS_SDK {
  Todo = "todo",
  FalseAlarm = "false_alarm",
  Close = "closed",
  Investigate = "investigate",
}

export enum ALERT_STATUS_DISPLAY {
  Todo = "To Do",
  FalseAlarm = "False Alarm",
  Close = "Close",
  Investigate = "Investigate",
}

export enum INVESTIGATE_TAG_DISPLAY {
  Loitering = "Loitering",
  Brawling = "Brawling",
  Trespassing = "Trespassing",
  Theft = "Theft",
  Firearm = "Firearm",
  Arson = "Arson",
  Injury = "Injury",
  IllegalDumping = "Illegal Dumping",
  DumpsterDiving = "Dumpster Diving",
  Encampment = "Encampment",
  Vandalism = "Vandalism",
  BreakIn = "Break In",
  DrugUse = "Drug Use",
  Others = "Others",
}

export enum INVESTIGATE_TAG_SDK {
  Loitering = "loitering",
  Brawling = "brawling",
  Trespassing = "trespassing",
  Theft = "theft",
  Firearm = "firearm",
  Arson = "arson",
  Injury = "injury",
  IllegalDumping = "illegal_dumping",
  DumpsterDiving = "dumpster_diving",
  Encampment = "encampment",
  Vandalism = "vandalism",
  BreakIn = "break_in",
  DrugUse = "drug_use",
  Others = "other",
}

export enum CASE_STATUS_DISPLAY {
  Close = "Case Close",
  Resolved = "Case Resolved",
  CallPd = "Call PD",
  Investigate = "Case Investigate",
}

export enum CASE_STATUS_SDK {
  Close = "closed",
  Resolved = "resolved",
  CallPd = "call_pd",
  Investigate = "investigate",
}

export const STATES = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

export enum IdentifiedServerError {
  // API ERROR
  AuthLastThirdParty = "auth.last_third_party",
  AudioTemplateNotFound = "code.not_found",
  DeviceUnAuthed = "device.un_authed",

  //Edge ERROR
  EdgeDownloaderNotExist = "edge.downloader_not_exist",
  EdgeDownloaderNoFile = "edge.downloader_no_file",
  EdgeWebrtcConnLimit = "edge.webrtc.conn_limit",
  EdgebandwidthLimit = "edge.bandwidth_limit",
  EdgeSpeedTesting = "edge.speed_testing",
}

export enum ConnectState {
  closed,
  connecting,
  opened,
}

export enum MicroState {
  muted, // disable mic
  opening, // opening mic
  speakable, // mic is enabled
}
